module.exports = __webpack_public_path__ + "img/not-found-mobil.e4a9f38c.png";